import { Input } from './input.component';

export * from './input.component';
export default Input;

Input.define('der-ui-input');

declare global {
    interface HTMLElementTagNameMap {
        'der-ui-input': Input;
    }
}
